export default __webpack_public_path__ + "static/media/mockRare.0d806c26.png";